// Fetch API in Edge v15 and v16 does not normalize
// the response header names to lower case as all
// other browsers do. Need to check both upper and lower
// case on the object to ensure we get the value.
const getHeaderValue = (headers, key) =>
  headers[key] || headers[key.toUpperCase()] || headers[key.toLowerCase()];

export default getHeaderValue;
